import { render } from "./SearchNext.vue?vue&type=template&id=0e09bee8"
import script from "./SearchNext.vue?vue&type=script&lang=js"
export * from "./SearchNext.vue?vue&type=script&lang=js"
script.render = render

export default script